import { useState } from "react";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { TESTIMONIALS } from "@/data/services";

export const WhyUs = () => {
  const [index, setIndex] = useState(0);
  const t = TESTIMONIALS[index];
  const prev = () => setIndex((i) => (i - 1 + TESTIMONIALS.length) % TESTIMONIALS.length);
  const next = () => setIndex((i) => (i + 1) % TESTIMONIALS.length);

  return (
    <section id="reviews" data-testid="testimonials-section" className="py-20 md:py-28">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
        <Quote className="mx-auto w-9 h-9 text-[#EA0A0B] fill-current" data-testid="testimonial-quote-icon" />

        <div className="relative mt-8 min-h-[180px] flex items-center justify-center">
          <button
            data-testid="testimonial-prev"
            onClick={prev}
            aria-label="Previous testimonial"
            className="absolute left-0 md:-left-16 top-1/2 -translate-y-1/2 p-2 text-slate-400 hover:text-[#FF4311] transition-colors"
          >
            <ChevronLeft className="w-7 h-7" />
          </button>

          <blockquote data-testid="testimonial-slide" key={index}>
            <p className="text-base md:text-lg text-slate-200 leading-relaxed">"{t.text}"</p>
            <footer className="mt-6">
              <p className="font-display uppercase text-base font-medium tracking-[0.12em] text-white">{t.name}</p>
              <p className="mt-1 text-sm text-slate-500">{t.vehicle}</p>
            </footer>
          </blockquote>

          <button
            data-testid="testimonial-next"
            onClick={next}
            aria-label="Next testimonial"
            className="absolute right-0 md:-right-16 top-1/2 -translate-y-1/2 p-2 text-slate-400 hover:text-[#FF4311] transition-colors"
          >
            <ChevronRight className="w-7 h-7" />
          </button>
        </div>

        <div data-testid="testimonial-dots" className="mt-8 flex items-center justify-center gap-2">
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              data-testid={`testimonial-dot-${i}`}
              onClick={() => setIndex(i)}
              aria-label={`Go to testimonial ${i + 1}`}
              className={`w-2 h-2 rounded-full transition-colors ${i === index ? "bg-[#EA0A0B]" : "bg-slate-600 hover:bg-slate-400"}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};
